module.exports = __webpack_public_path__ + "img/icon-close.d72f7e4e.svg";